import { type FinCategory, isRealEstate } from '#dictionary'
import MemberService from '#profile/MemberService'

import FinancialRecord, { type FinancialRecordPayload } from './FinancialRecord'
import RealEstateRecord from './RealEstateRecord'

const createFinancialRecord = (
  payload: FinancialRecordPayload,
  finCategory: FinCategory,
  owner: MemberService
): FinancialRecord =>
  isRealEstate(finCategory)
    ? new RealEstateRecord(payload, finCategory, owner)
    : new FinancialRecord(payload, finCategory, owner)

export default createFinancialRecord
